var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "font_style_group" },
    [
      _c(
        "span",
        {
          class: {
            "style_item style_item_through": true,
            style_item_active:
              _vm.decoration === "line-through" ||
              _vm.$store.state.color.isShow,
            bg_color: _vm.scShow === true,
          },
          on: {
            click: function ($event) {
              return _vm.on_click_decoration("line-through")
            },
          },
        },
        [
          _c(
            "svg",
            { staticClass: "icon img-icon", attrs: { "aria-hidden": "true" } },
            [_c("use", { attrs: { "xlink:href": "#icon-xiahuaixian16" } })]
          ),
        ]
      ),
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: { effect: "dark", content: "加粗", placement: "top" },
        },
        [
          _c(
            "span",
            {
              class: {
                "style_item style_item_weight": true,
                style_item_active: _vm.weight === "bold",
              },
              on: { click: _vm.on_click_weight },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon img-icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#icon-jiacu16" } })]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: { effect: "dark", content: "斜体", placement: "top" },
        },
        [
          _c(
            "span",
            {
              class: {
                "style_item style_item_style": true,
                style_item_active: _vm.style === "italic",
              },
              on: { click: _vm.on_click_style },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon img-icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#icon-xieben16" } })]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: { effect: "dark", content: "下划线", placement: "top" },
        },
        [
          _c(
            "span",
            {
              class: {
                "style_item style_item_underline": true,
                style_item_active: _vm.decoration === "underline",
                bg_color: _vm.xhxShow === true,
              },
              on: {
                click: function ($event) {
                  return _vm.on_click_decoration("underline")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon img-icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("use", { attrs: { "xlink:href": "#icon-xiahuaixian162" } })]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }